import React from 'react';
import { Redirect } from '@avangard/utils/routing';
import { useLocationQuery } from '@avangard/utils/hooks';

import { routes } from '@config/routes';
import { ResetPasswordForm } from '@modules/auth/organisms';

const ResetPasswordPage = (): React.ReactElement | null => {
    const { query } = useLocationQuery();

    if (!query.token) {
        return <Redirect noThrow to={routes.index.path} />;
    }

    return <ResetPasswordForm />;
};

export { ResetPasswordPage };
